export default () => ({
  salesAll: [],
  salesYear: [],
  salesMonth: [],
  salesDay: [],
  salesItems: [],
  salesItemsAll: [],

  salesAllNonFiscal: [],
  salesYearNonFiscal: [],
  salesMonthNonFiscal: [],
  salesDayNonFiscal: [],

  totalRows: 0.0,
  totalDebt: 0.0,
  totalDebtExpired: 0.0,
  totalPaidOut: 0.0,
  fifteenDaysExpiredTotal: 0.0,
  thirtyDaysExpiredTotal: 0.0,
  fortyFiveDaysExpiredTotal: 0.0,
  sixtyDaysExpiredTotal: 0.0,
  fifteenDaysToExpiredTotal: 0.0,
  thirtyDaysToExpiredTotal: 0.0,
  fortyFiveDaysToExpiredTotal: 0.0,
  sixtyDaysToExpiredTotal: 0.0,
});
